import { calculateSeatsUsed } from '~teacher/components/Account/helpers';
import { useTeams, useTeamsMembers } from '~teacher/hook/team';

/**
 * This is a custom hook that can be used to calculate available seats.
 */
export function useCalculateSeatsAvailable(teamId: string) {
  const teamMembers = useTeamsMembers({ teamId: teamId });

  const totalSeats = useTeams({
    select: (data) => {
      const team = data.find((t) => t.id === teamId);
      return team?.subscription?.totalSeats;
    },
    enabled: !!teamId,
  });

  const seatsAvailable = calculateSeatsUsed({
    totalSeats: totalSeats.data,
    teamMembers: teamMembers.data,
  });

  return {
    queries: [teamMembers, totalSeats],
    seatsAvailable,
  };
}
